const projects = [
  {
    id: 1,
    title: "Splash Swimming Pool",
    category: "Designing Beyond Mockups",
    url: "https://splash-swimming-pool.vercel.app/",
    image: "/images/projects/splash.png",
    description:
      "A playful front-end experience exploring visual interaction, layout, and responsive web design.",
    tags: ["React", "Front-End", "Interaction"],
  },
  {
    id: 2,
    title: "Interactive Web Prototype",
    category: "Designing Beyond Mockups",
    url: "https://project2-m1.vercel.app/",
    image: "/images/projects/pet.png",
    description:
      "A static web project focused on structure, navigation, and front-end implementation.",
    tags: ["React", "Static Data", "Web Design"],
  },
  {
    id: 3,
    title: "Keplore Front",
    category: "Designing Beyond Mockups",
    url: "https://keplore-front.vercel.app/",
    image: "/images/projects/keplore.png",
    description:
      "A front-end prototype exploring AI product interfaces, visual systems, and product storytelling.",
    tags: ["AI Interface", "Product Design", "Front-End"],
  },
];

export default projects;
